import React, { FunctionComponent, memo, useCallback } from 'react'

import { Grid } from '@material-ui/core'
import { format } from 'date-fns'
import { IConsultaExtratoDetalheItem } from 'modules/pagamentos/domain/entities/IFindAllExtratoResponse'

import {
  ContainerItem,
  GridContainer,
  TextTime,
  TextType,
  TextDoc,
  CardType,
  MoneyValue,
} from './styles'

interface IExtratoItemProps {
  item: IConsultaExtratoDetalheItem
}

const CARGA_ADIANTAMENTO = 1
const CARGA_SALDO = 2
const TRANSF_ABAST_CONTAS = 11
const TRANSF_SALDO_CONTAS = 12
const TRANSF_CONTA_BANCAR = 23
const TRANSF_OUTRA_CONT_BANCAR = 50

const ExtratoItem: FunctionComponent<IExtratoItemProps> = ({ item }) => {
  const dateExtrato = new Date(item.data)

  const formatMoney = (value: number) => {
    return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  }

  const renderDoc = useCallback(() => {
    const isTipoContaCorrente = () => {
      return item.info_adicional.tipo_conta === 'Corrente'
    }

    if (
      (item.historico_id === TRANSF_ABAST_CONTAS ||
        item.historico_id === TRANSF_SALDO_CONTAS) &&
      item.info_adicional.documento_favorecido
    ) {
      return (
        <TextDoc>
          Documento favorecido:{' '}
          <span>{item.info_adicional.documento_favorecido}</span>
        </TextDoc>
      )
    }

    if (
      item.historico_id === TRANSF_CONTA_BANCAR ||
      item.historico_id === TRANSF_OUTRA_CONT_BANCAR
    ) {
      return (
        <TextDoc>
          Favorecido:{' '}
          <span>{`BC: ${item.info_adicional.codigo_banco} AG: ${
            item.info_adicional.agencia
          }/${isTipoContaCorrente() ? 'CC' : 'CP'}: ${
            item.info_adicional.conta_bancaria
          }-${item.info_adicional.digito_conta}`}</span>
        </TextDoc>
      )
    }

    if (
      (item.historico_id === CARGA_ADIANTAMENTO ||
        item.historico_id === CARGA_SALDO) &&
      item.info_adicional.cte
    ) {
      return (
        <TextDoc>
          CT-e: <span>{item.info_adicional.cte}</span>
        </TextDoc>
      )
    }
  }, [
    item.historico_id,
    item.info_adicional.documento_favorecido,
    item.info_adicional.agencia,
    item.info_adicional.codigo_banco,
    item.info_adicional.conta_bancaria,
    item.info_adicional.digito_conta,
    item.info_adicional.tipo_conta,
    item.info_adicional.cte,
  ])

  const renderSituacao = useCallback(() => {
    if (
      item.historico_id === TRANSF_CONTA_BANCAR &&
      item.info_adicional.situacao
    ) {
      return <CardType>{item.info_adicional.situacao}</CardType>
    }
  }, [item.historico_id, item.info_adicional.situacao])

  return (
    <ContainerItem>
      <GridContainer container alignItems="center" item xs={12}>
        <Grid item xs={6}>
          <TextTime>{format(dateExtrato, 'dd/MM/yyyy HH:mm')}</TextTime>
          <TextType>
            {item.historico_id
              ? `${item.historico} - ${item.descricao_processadora}`
              : item.descricao_processadora}
          </TextType>
          {renderDoc()}
        </Grid>
        <Grid
          item
          xs={6}
          style={{ height: '100%' }}
          container
          direction="column"
          alignItems="flex-end"
          justifyContent="space-between"
        >
          {item?.info_adicional?.tipo_info_adicional && (
            <CardType>{item.info_adicional.tipo_info_adicional}</CardType>
          )}
          {renderSituacao()}
          <MoneyValue isDebit={item.tipo === 'D'}>
            {item.tipo === 'D'
              ? `-${formatMoney(item.valor)}`
              : `${formatMoney(item.valor)}`}
          </MoneyValue>
        </Grid>
      </GridContainer>
    </ContainerItem>
  )
}

export default memo(ExtratoItem)
